module.exports = __webpack_public_path__ + "img/panorama-preload.ffdda73.jpg";